import React from 'react';
import cls from 'classnames';
import { map } from '../../../utils';
import styles from './sparks.module.scss';

type Props = {
  /**
   * Spark count.
   */
  count?: number;

  sparkClassName?: string;

  /**
   * Spark count to skip.
   */
  offset?: number;

  /**
   * Spark width in px.
   */
  width?: number;

  /**
   * Spark length in px.
   */
  length?: number;

  _ref?: (ref: { trigger: () => void; }) => void;

  style?: React.CSSProperties;
};

/**
 * Emits several animated sparks.
 * @author Johan Svensson
 */
export const Sparks: React.FC<Props> = (
  { sparkClassName, count = 5, width = 3, length = 12, offset = 0, _ref, style }
) => {
  const [triggerCount, setTriggerCount] = React.useState(0);

  React.useEffect(() => {
    _ref?.({ trigger: () => setTriggerCount(c => c + 1) });
  }, []);

  if (!triggerCount) {
    return null;
  }

  const bounds = width * 2;

  return (
    <span key={triggerCount}
      className={styles.container}
      style={{ ...style, width: bounds, height: bounds }}>
      {map(count, i => (
        <Spark
          index={i}
          key={i}
          sparkClassName={sparkClassName}
          length={length}
          width={width}
          count={count}
          offset={offset} />
      ))}
    </span>
  )
}

function Spark({ sparkClassName: className, length, width, index, count, offset }: Props & { index: number }) {
  const rotation = (360 / (count + offset)) * (index - offset + 1);

  return (
    <span
      className={styles.sparkAnchor}
      style={{ transform: `translate(-50%, -50%) rotate(${rotation}deg)` }}>
      <span
        className={cls([styles.spark, className])}
        style={{
          width,
          borderRadius: width / 2,
          height: length
        }}>

      </span>
    </span>
  )
}